import { CloseOutlined } from "@ant-design/icons";
import { Button, Input } from "antd";
import { useMemo, useState } from "react";
import { sideBarFeatureEvent$ } from "../../api/eventBus";
import { eventBusType } from "../../config/Constant";
import { useAuthLayoutContext } from "../../context/AuthLayoutContext";
import { useMenuContext } from "../../context/MenuContext";
import { useSideBarStore } from "../../store/SideBarStore";
import { useInfoUser } from "../../store/UserStore";
import { useDirectoryContext } from "../select/directory/DirectoryContext";
import { QuickDirectory } from "../select/directory/QuickDirectory";
import { HiRefresh } from "react-icons/hi";
import { QuickOnlineList } from "../select/directory/QuickOrganization";
import { IoSearchOutline } from "react-icons/io5";
import { debounce } from "lodash";
import apiFactory from "../../api";
import {
  update2WayOrgList,
  updateOrgList,
} from "../../utils/OrganizationHelper";

const SideBarOrganization = () => {
  const { languageMap } = useInfoUser();

  const { debouncedFilterOrg } = useDirectoryContext();
  const { setIsOrganizationSideBar, isOrganizationSideBar } = useSideBarStore(
    (state) => state,
  );

  const { selectedConversation } = useMenuContext();

  const { fetchOrganizations, setOrgList } = useAuthLayoutContext();

  const [activeTab, setActiveTab] = useState("organization");
  const [searchQuery, setSearchQuery] = useState("");
  const [search, setSearch] = useState("");

  const debouncedFilterOnline = useMemo(
    () =>
      debounce((text) => {
        setSearchQuery(text?.toUpperCase());
      }, 500),
    [],
  );

  const onFilter = (event) => {
    setSearch(event.target.value.trim());

    if (activeTab === "organization") {
      debouncedFilterOrg(event.target.value.trim());
    } else {
      debouncedFilterOnline(event.target.value.trim());
    }
  };

  const initFilterOrganization = () => {
    setActiveTab("organization");
    debouncedFilterOrg(search);
  };

  const initFilterOnline = async () => {
    setActiveTab("online");
    const result = await apiFactory.organizationUserApi.getOnline();

    update2WayOrgList(setOrgList, result?.data);

    debouncedFilterOnline(search);
  };

  const handleRefreshOrganization = () => {
    // Fetch organization data again
    fetchOrganizations();
  };

  const SidebarMenuStyle = useMemo(() => {
    if (!isOrganizationSideBar) {
      return "detail-chat-menu hidden";
    }

    if (!selectedConversation?.conversationId) {
      return "detail-chat-menu !block w-full";
    }

    return "detail-chat-menu";
  }, [selectedConversation?.conversationId, isOrganizationSideBar]);

  return (
    <div className={SidebarMenuStyle}>
      <div className="header justify-between">
        <div className="flex gap-[5px]">
          <Button
            className={`${activeTab === "organization" ? "conversation-tab-selected" : "conversation-tab-unselected"}`}
            onClick={initFilterOrganization}
          >
            {languageMap?.["menuOrg.title.organization"] ?? "Organization"}
          </Button>
          <Button
            className={`${activeTab === "online" ? "conversation-tab-selected" : "conversation-tab-unselected"}`}
            onClick={initFilterOnline}
          >
            {languageMap?.["menuOrg.title.online"] ?? "Online"}
          </Button>
        </div>

        <div className="flex items-center gap-2">
          {/* Refresh */}
          <Button
            type="text"
            icon={<HiRefresh className="text-[18px]" />}
            onClick={handleRefreshOrganization}
            title="Refresh"
          />

          {/* Close */}
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={() => {
              setIsOrganizationSideBar(false);
              setActiveTab("organization");
              setSearch("");
              sideBarFeatureEvent$.next({
                type: eventBusType.CONVERSATION,
              });
            }}
            title="Close"
          />
        </div>
      </div>
      <div>
        <Input
          className="w-[96%] mt-2 ml-[10px]"
          placeholder={languageMap?.["menu.search.placeholder"] ?? "Search"}
          value={search}
          onChange={onFilter}
          prefix={<IoSearchOutline size={15} />}
          allowClear
        />
        <QuickDirectory activeTab={activeTab} />
        <QuickOnlineList activeTab={activeTab} searchQuery={searchQuery} />
      </div>
    </div>
  );
};

export default SideBarOrganization;
